<template>
  <div class="main">
    <el-scrollbar class="nav-scollbar" :style="fullHeight">
      <div class="title-box">
        <el-row>
          <el-col :span="4">
            <div class="grid-content bg-purple">
              <img src="../assets/images/zsLogo.png" style="margin-top: 24px;width:100%;" v-if="showQuDao"/>
              <img src="../assets/images/qxLogo.png" style="margin-top: 24px;width:100%;" v-else/>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="logo-title" v-if="showQuDao">
              <p class="logo-p">渠道无忧旗下招商智投</p>
              <p> 数据分析系统</p>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="grid-content bg-purple-light">
              <!-- <el-button type="primary" class="nav-btn" @click="skip('/')">返回首页</el-button> -->
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="content" :style="{ height: fullHeight }">
        <div class="login">
          <h3 class="login-title">密码登录</h3>
          <el-form :model="form" class="login-form" size="large" @keyup.enter.native="login" ref="form">
            <el-form-item
              prop="loginAccount"
              :rules="[
                  { required: true, message: '请输入账号' },
                  { min: 3, max: 15, message: '长度在 3 到 15 个字符' }
                ]">
              <el-input v-model="form.loginAccount" placeholder="账户名/手机号码">
              </el-input>
            </el-form-item>
            <el-form-item
              prop="password"
              :rules="[
                  { required: true, message: '请输入密码' }
                ]">
              <el-input v-model="form.password" type="password" placeholder="密码">
              </el-input>
            </el-form-item>
            <el-form-item size="mini">
              <el-checkbox v-model="rememberMe" label="记住账号"/>
              <!--<a href="/pass" class="pass">忘记密码</a>-->
            </el-form-item>
            <el-form-item>

              <el-button v-if="logining" class="btn-login" type="info" disabled>正在登录...</el-button>
              <el-button v-else class="btn-login" type="primary" @click="login">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="footer" v-if="showQuDao">
        <div class="copyright">Copyright © 2013-2019 qudaowuyou. All Rights Reserved 广州渠道无忧网络技术服务有限公司</div>
        <div class="serial">粤ICP备13036846号</div>
      </div>
      <div class="footer" v-else>
        <div class="copyright">Copyright © 2022 qixiangwangluo All Rights Reserved 广州祺祥网络技术有限公司</div>
        <div class="serial">粤ICP备13036846号</div>
      </div>
    </el-scrollbar>
    <el-dialog
    title="修改密码"
    :visible.sync="changePassword"
    width="30%"
    center
    style="border-radius: 10px;"
    >
      <div style="text-align: center;font-size: 20px;color:#4d9fe5;margin-bottom: 30px;">为了你的账号安全，系统会不定期要求修改登录密码</div>
      <el-form ref="roleForm" label-width="120px" :model="ruleForm" :rules="rules">
        <el-form-item label="原密码：" prop="oldPassword">
          <el-input v-model="ruleForm.oldPassword" :type="[flag?'text':'password']" style="border:1px solid #fff;width:300px;" placeholder="请输入密码">
      <i slot="suffix" :class="[flag?'el-icon-minus':'el-icon-view']" style="margin-top:8px;font-size:18px;" autocomplete="auto" @click="flag=!flag" />
    </el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="newPassword">
          <el-input v-model="ruleForm.newPassword" :type="[flag?'text':'password']" style="border:1px solid #fff;width:300px;" placeholder="请输入新密码（8-18位字母和数字）">
      <i slot="suffix" :class="[flag?'el-icon-minus':'el-icon-view']" style="margin-top:8px;font-size:18px;" autocomplete="auto" @click="flag=!flag" />
    </el-input>

        </el-form-item>
        <el-form-item label="确认新密码：" prop="confirmPassword">
          <el-input v-model="ruleForm.confirmPassword" :type="[flag?'text':'password']" style="border:1px solid #fff;width:300px;" placeholder="请再次输入新密码（8-18位字母和数字）">
      <i slot="suffix" :class="[flag?'el-icon-minus':'el-icon-view']" style="margin-top:8px;font-size:18px;" autocomplete="auto" @click="flag=!flag" />
    </el-input>

        </el-form-item>
      </el-form>
      <div style="text-align: center;margin-top: 40px;">
        <el-button type="primary" @click="updaPassword('roleForm')" >保存</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import UserApi from '@/api/system/user'
  const _CK_LOGIN_ACCOUNT = '_qd_emcp.b_u'
  export default {
    data () {
      return {
        showQuDao: true,
        flag: false,
        logining: false,
        timer: false,
        fullHeight: (document.documentElement.clientHeight - 195) + 'px',
        form: {
          loginAccount: '',
          password: '',
          type: 1 // 0为快速登录
        },
        rememberMe: true,
        changePassword: false,
        ruleForm: {
          newPassword: '',
          oldPassword: '',
          confirmPassword: '',
          loginAccount: ''
        },
        rules: {
          oldPassword: [
            { required: true, message: '请输入原密码', trigger: 'blur' }
            // {
            //   pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,18}$/, message: '（8-18位字母和数字）', trigger: 'blur'
            // }
          ],
          newPassword: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            {
              pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,18}$/, message: '密码（8-18位字母和数字），请重新输入', trigger: 'blur'
            }
          ],
          confirmPassword: [
            { required: true, message: '请再次输入新密码', trigger: 'blur' },
            {
              pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,18}$/, message: '密码（8-18位字母和数字），请重新输入', trigger: 'blur'
            }
          ]
        }
      }
    },
    created () {
      if (window.location.host !== 'test-emcp.qudao51.com' && window.location.host !== 'www.qudao51.com') {
        this.showQuDao = false
      }
      if (window.location.host === 'localhost:8030') {
        this.showQuDao = true
      }
      const loginAccount = this.getQueryString('account')
      if (loginAccount) {
        const password = this.getQueryString('psw')
        this.form.type = 0
        this.form.loginAccount = loginAccount
        this.form.password = password
        this.quickLogin()
      }
      const that = this
      window.onresize = () => {
        return (() => {
          window.fullHeight = (document.documentElement.clientHeight - 195) + 'px'
          that.fullHeight = window.fullHeight
        })()
      }
    },
    methods: {
      updaPassword (roleForm) {
        this.$refs[roleForm].validate(async (valid) => {
          if (valid) {
            if (this.ruleForm.newPassword !== this.ruleForm.confirmPassword) {
              this.$message.error('新密码与确认新密码不一致，请重新输入')
              return
            }
            if (this.ruleForm.newPassword === this.ruleForm.oldPassword) {
              this.$message.error('新密码不能与旧密码一样')
              return
            }
            if (this.ruleForm.oldPassword !== this.form.password) {
              this.$message.error('原密码错误，请重新输入')
              return
            }
            this.ruleForm.loginAccount = this.form.loginAccount
            const data = await UserApi.passwordFn(this.ruleForm)
            if (data.data.code === '200') {
              this.$message.success('密码修改成功，请重新登录')
              this.changePassword = false
              this.form.password = ''
            }
            console.log(data)
          }
        })
      },
      skip (a) {
        this.$router.push(a)
      },
      quickLogin () {
        this.logining = true
        UserApi.login(this.form, (response) => {
          let status = response.data.code
          let body = response.data.data || {}
          if (status === '200') {
            this.$cookie.set('_qd_emcp.l_s', 'true')
            this.$router.push('/work-bench')
            window.location.reload()
            this.$message.success('登录成功')
          } else {
            this.$message.error(response.data.msg || '登录失败')
          }
          this.logining = false
        })
      },
      login () {
        if (this.logining) {
          return
        }
        this.$refs['form'].validate(valid => {
          if (valid) {
            // 记住账号
            if (this.rememberMe) {
              this.$cookie.set(_CK_LOGIN_ACCOUNT, this.form.loginAccount)
            } else {
              this.$cookie.delete(_CK_LOGIN_ACCOUNT)
            }
            this.logining = true
            UserApi.login(this.form, (response) => {
              let status = response.data.code
              let body = response.data.data || {}
              if (status === '200') {
                this.$cookie.set('_qd_emcp.l_s', 'true')
                sessionStorage.setItem('user', JSON.stringify(body))
                this.$router.push('/work-bench')
                window.location.reload()
                this.$message.success('登录成功')
              } else if (status === '10002') {
                this.changePassword = true
              } else {
                this.$message.error(response.data.msg || response.data.error || '登录失败')
              }
              this.logining = false
            })
          }
        })
      },
      getQueryString (name) {
        let url = window.location.href
        let resultStr = ''
        let tempArr = url.split(name + '=')
        if (tempArr.length > 1) {
          url = tempArr[1]
          tempArr = url.split('&')
          resultStr = tempArr[0]
        }
        return decodeURIComponent(resultStr)
      }
    }
  }
</script>

<style scoped="scoped" lang="scss">
  .main {
    width: 100%;
    height: 100%;
    display: flex;
    .flex-scrollbar {
      width: auto;
      height: auto;
      -webkit-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
    }
    .nav-scollbar {
      width: 100%;
      height: 100%;
      overflow-x: hidden;
    }
    .title-box {
      width: 1200px;
      height: 102px;
      line-height: 102px;
      margin: 0 auto;
      .logo-title {
        height: 32px;
        padding: 1px 0 0 25px;
        box-sizing: border-box;
        margin: 35px 0 0 25px;
        border-left: 2px solid #666;
        > p {
          font-size: 14px;
          color: #5d5d5d;
          line-height: 8px;
          margin-top: 0px;
        }
      }
    }
    .nav-btn {
      margin-left: 60%;
      background: #085ECC;
      &:hover {
        background: #4a98ff;
        transition-duration: 0.5s;
      }
    }
    .content {
      width: 100%;
      background: url("../assets/images/background.png") center;
      position: relative;
      .login {
        width: 480px;
        height: 390px;
        background: white;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        .login-title {
          width: 100%;
          height: 60px;
          background: #f9f9f9;
          font-size: 20px;
          color: #085ECC;
          text-align: center;
          line-height: 60px;
          padding: 0;
          margin: 0;
        }
        .login-form {
          padding: 0 50px;
          box-sizing: border-box;
          margin-top: 50px;
          .btn-login {
            width: 380px;
            background: #085ECC;
            &:hover {
              background: #4a98ff;
              transition-duration: 0.5s;
            }
          }
          .pass {
            text-decoration: none;
            margin-left: 200px;
            color: #085ecc;
          }
        }
      }
    }
    .footer {
      width: 100%;
      height: 110px;
      background: #232526;
      padding-top: 12px;
      box-sizing: border-box;
      .copyright {
        text-align: center;
        margin: 20px 0 10px 0;
        font-size: 14px;
        color: white;
      }
      .serial {
        text-align: center;
        font-size: 14px;
        color: #A6A7AA;
      }
    }
  }
</style>
<style lang="scss">
  .main {
    .nav-scollbar {
      .el-scrollbar__wrap {
        overflow: hidden;
        .el-scrollbar__view {
          .content {
            .login {
              .el-form {
                .el-form-item {
                  .el-form-item__content {
                    .el-checkbox {
                      .el-checkbox__label {
                        color: #085ECC;
                      }
                      .el-checkbox__input {
                        .el-checkbox__inner {
                          /*background-color: #085ECC;*/
                          border-color: #085ECC;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Login.vue